<div class="thread-message">
	<div class="thread-message-created">
		<div class="thread-message-created-icon"><i class="fa-sharp fal fa-arrow-right-long"></i></div>
		<div class="thread-message-created-text">{{msg().createdAt | date: "short"}}</div>
	</div>
	<div class="thread-message-content markdown" [innerHTML]="msg().contentParsed"></div>
</div>